export default __webpack_public_path__ + "static/media/1(JWMarriot).50bb75d1.jpg";